<div class="row mt-10" [formGroup]="form">
  <ng-container *ngIf="viewModel$|async as viewModel">
    <div class="col-12">
      <div class="row">
        <div class="col-4">
          <div class="row">
            <div class="col-12 font-weight-bolder">
              Comparables Price Range
            </div>
            <div class="col-12 mt-4">
              <mat-form-field class="mat-form-field-fluid" [formFieldState]="form.controls['comparable_lower_end']">
                <input matInput formControlName="comparable_lower_end"
                  [placeholder]="'Comparables Price lower end per ' + viewModel.unit" 
                  mask="separator.2"
                  thousandSeparator=","
                  [suffix]="currency$|async" />
                <mat-hint [formFieldHintState]="form.controls['comparable_lower_end']">
                  Required
                </mat-hint>
                <mat-error>
                  Required
                </mat-error>
              </mat-form-field>
            </div>

            <div class="col-12 mt-4">
              <mat-form-field class="mat-form-field-fluid" [formFieldState]="form.controls['comparable_higher_end']">
                <input matInput formControlName="comparable_higher_end"
                  [placeholder]="'Comparables Price higher end per ' + viewModel.unit" mask="separator.2"
                  thousandSeparator="," 
                  [suffix]="currency$|async" />
                <mat-hint [formFieldHintState]="form.controls['comparable_higher_end']">
                  Required
                </mat-hint>
                <mat-error>
                  Required
                </mat-error>
              </mat-form-field>
            </div>
          </div>
        </div>

        <!-- <div class="col-4">
          <div class="row">
            <div class="col-12 font-weight-bolder">
              Consultant expectations
            </div>
            <div class="col-12 mt-4">
              <mat-form-field class="mat-form-field-fluid" [formFieldState]="form.controls['consultant_lower_end']">
                <input matInput formControlName="consultant_lower_end" [placeholder]="'Lower end per ' + viewModel.unit"
                  mask="separator.2" thousandSeparator="," 
                  [suffix]="currency$|async" />
                <mat-hint [formFieldHintState]="form.controls['consultant_lower_end']">
                  Required
                </mat-hint>
                <mat-error>
                  Required
                </mat-error>
              </mat-form-field>
            </div>

            <div class="col-12 mt-4">
              <mat-form-field class="mat-form-field-fluid" [formFieldState]="form.controls['consultant_higher_end']">
                <input matInput formControlName="consultant_higher_end"
                  [placeholder]="'Higher end per ' + viewModel.unit" mask="separator.2" thousandSeparator="," 
                  [suffix]="currency$|async" />
                <mat-hint [formFieldHintState]="form.controls['consultant_higher_end']">
                  Required
                </mat-hint>
                <mat-error>
                  Required
                </mat-error>
              </mat-form-field>
            </div>
          </div>
        </div> -->

        <!-- <div class="col-4">
          <div class="row">
            <div class="col-12 font-weight-bolder">
              Valuer's opinion on comparables prices
            </div>
            <div class="col-12 mt-4">
              <mat-form-field class="mat-form-field-fluid" [formFieldState]="form.controls['valuer_lower_end']">
                <input matInput formControlName="valuer_lower_end" [placeholder]="'Lower end per ' + viewModel.unit"
                  mask="separator.2" thousandSeparator="," 
                  [suffix]="currency$|async" />
                <mat-hint [formFieldHintState]="form.controls['valuer_lower_end']">
                  Required
                </mat-hint>
                <mat-error>
                  Required
                </mat-error>
              </mat-form-field>
            </div>

            <div class="col-12 mt-4">
              <mat-form-field class="mat-form-field-fluid" [formFieldState]="form.controls['valuer_higher_end']">
                <input matInput formControlName="valuer_higher_end" [placeholder]="'Higher end per ' + viewModel.unit"
                  mask="separator.2" thousandSeparator="," 
                  [suffix]="currency$|async" />
                <mat-hint [formFieldHintState]="form.controls['valuer_higher_end']">
                  Required
                </mat-hint>
                <mat-error>
                  Required
                </mat-error>
              </mat-form-field>
            </div>
          </div>
        </div> -->
      </div>

      <div class="row mt-10">
        <div class="col-12 font-weight-bolder">
          Valuer's opinion on Subject Property
        </div>
        <div class="col-12 mt-4">
          <mat-form-field class="mat-form-field-fluid" [formFieldState]="form.controls['reasoning']">
            <textarea matInput formControlName="reasoning" placeholder="Weighting & Reasoning justification"></textarea>
            <mat-hint [formFieldHintState]="form.controls['reasoning']">
              Required
            </mat-hint>
            <mat-error>
              Required
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col-12 mt-4">
          <div class="row">
            <div class="col-4">
              <mat-form-field class="mat-form-field-fluid" [formFieldState]="form.controls['value_range_id']">
                <mat-select formControlName="value_range_id" placeholder="Value range">
                  <mat-option [value]="1">Bottom</mat-option>
                  <mat-option [value]="2">Middle</mat-option>
                  <mat-option [value]="2">Top</mat-option>
                </mat-select>
                <mat-hint [formFieldHintState]="form.controls['value_range_id']">
                  Required
                </mat-hint>
                <mat-error>
                  Required
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-4">
              <mat-form-field class="mat-form-field-fluid" [formFieldState]="form.controls['value_estimated']">
                <input matInput formControlName="value_estimated" [placeholder]="'Value Estimated per ' + viewModel.unit" 
                  mask="separator.2" thousandSeparator="," 
                  [suffix]="currency$|async" />
                <mat-hint [formFieldHintState]="form.controls['value_estimated']">
                  Required
                </mat-hint>
                <mat-error>
                  Required
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-4">
              <ng-container *ngIf="totalValue$|async as totalValue">
                <div class="font-weight-bolder">
                  <span>Total Value: </span>
                  <span>{{totalValue | mask:'separator.2':{thousandSeparator:','} }}</span>
                  <span>{{currency$|async}}</span>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-6">
          <div class="row">
            <div class="col-12 font-weight-bolder">
              Market rental range
            </div>
            <div class="col-12 mt-4">
              <mat-form-field class="mat-form-field-fluid" [formFieldState]="form.controls['rental_value_lower_end']">
                <input matInput formControlName="rental_value_lower_end"
                  placeholder="Rental Value per annum lower end" mask="separator.2"
                  thousandSeparator="," 
                  [suffix]="currency$|async" />
                <mat-hint [formFieldHintState]="form.controls['rental_value_lower_end']">
                  Required
                </mat-hint>
                <mat-error>
                  Required
                </mat-error>
              </mat-form-field>
            </div>

            <div class="col-12 mt-4">
              <mat-form-field class="mat-form-field-fluid" [formFieldState]="form.controls['rental_value_higher_end']">
                <input matInput formControlName="rental_value_higher_end"
                  placeholder="Rental Value per annum higher end" mask="separator.2"
                  thousandSeparator="," 
                  [suffix]="currency$|async" />
                <mat-hint [formFieldHintState]="form.controls['rental_value_higher_end']">
                  Required
                </mat-hint>
                <mat-error>
                  Required
                </mat-error>
              </mat-form-field>
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="row">
            <div class="col-12 font-weight-bolder">
              Market Value of the Land (if vacant)
            </div>
            <div class="col-12 mt-4">
              <mat-form-field class="mat-form-field-fluid" [formFieldState]="form.controls['land_value']">
                <input matInput formControlName="land_value"
                  placeholder="Land Value (assumed vacant)" mask="separator.2"
                  thousandSeparator="," 
                  [suffix]="currency$|async" />
                <mat-hint [formFieldHintState]="form.controls['land_value']">
                  Required
                </mat-hint>
                <mat-error>
                  Required
                </mat-error>
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>